import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ILabTest, LabTest } from '../LabTest.ts';
import { LabTestApi } from '../../../apis/LabTestApi/LabTestApi.ts';

export function useGetPendingLabTests(patientId?: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.pendingLabTests, patientId],
        queryFn: async () => {
            const result: ILabTest[] = await LabTestApi.getPendingLabTests(patientId!);
            return result.map((el) => new LabTest(el));
        },
        enabled: !!patientId,
    });
} 